import { InjectOptions, Injector, Provider } from "@angular/core";

import { QUERY_RESOLVER } from "./query-hub.constants";
import { QueryResolver } from "../models/query-resolver.interface";
import { QueryResolverService } from "../services/query-resolver.service";


function queryResolverFactoryFn(injector: Injector): QueryResolver {
    // Look for parent instance.
    const options: InjectOptions = { optional: true, skipSelf: true };
    const resolver: QueryResolver = injector.get(QUERY_RESOLVER, null, options);

    if (!!resolver) return resolver;

    // Otherwise create a new instance.
    const child: Injector = Injector.create({
        providers: [{ provide: QueryResolverService }],
        parent: injector,
    });

    return child.get(QueryResolverService);
}

export const queryResolverProvider: Provider = {
    useFactory: queryResolverFactoryFn,
    provide: QUERY_RESOLVER,
    deps: [Injector]
}